import { FabNewPostButton } from "./EntryNewPostButton.styles";
import { PenSolidIcon } from "../Icon/PenSolidIcon";
import FabPositioned from "../FabPositioned/FabPositioned";

export function EntryNewPostButton({
    onClick,
    backgroundColor,
}: {
    onClick: () => void;
    backgroundColor?: string;
}) {
    return (
        <FabPositioned hideOnEndOfView={true} position="right">
            <FabNewPostButton
                backgroundColor={backgroundColor}
                onClick={onClick}
                disableRipple={true}
                disableFocusRipple={true}
                disableTouchRipple={true}
            >
                <PenSolidIcon color={"var(--community-color-snow-white)"} />
            </FabNewPostButton>
        </FabPositioned>
    );
}
